import { gql } from '@apollo/client';

export const OVERRIDE_METADATA_NUMBER_FIELDS = gql`
  fragment OverrideMetadataNumberFields on OverrideMetadataNumber {
    effectiveValue
    overrideValue
    fallbackValue
    overridden
  }
`;

export const OVERRIDE_METADATA_STRING_FIELDS = gql`
  fragment OverrideMetadataStringFields on OverrideMetadataString {
    effectiveValue
    overrideValue
    fallbackValue
    overridden
  }
`;
